import { Link } from 'react-router-dom';
import { React, useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import './Breadcrumb.css';

const Breadcrumb = ({ items }) => {
  const { language } = useContext(LanguageContext);
  return (
    <nav className="breadcrumb">
      {items.map((item, index) => (
        <div key={index}>
          {index > 0 && <span className="breadcrumb-separator"> &gt; </span>}
          {item.href ? (
            <Link to={item.href.startsWith(`/${language.value}`) ? item.href : `/${language.value}${item.href}`} className="breadcrumb-link">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-current">{item.label}</span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;